import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import {
  AiAgentUiCommand,
  AiAgentUiCommandContext,
  AiAgentUiCommandHandler,
} from "../ai-agent-ui-command.types";

@Injectable({ providedIn: "root" })
export class OpenContactHandler implements AiAgentUiCommandHandler {
  constructor(private router: Router) {}

  supports(type: string): boolean {
    return type === "openContact";
  }

  async handle(cmd: AiAgentUiCommand, _ctx?: AiAgentUiCommandContext): Promise<void> {
    if (cmd.contactId === undefined || cmd.contactId === null) {
      return;
    }
    if (!cmd.companyId) {
      return;
    }
    await this.router.navigate(["/contacts", cmd.contactId, cmd.companyId, "contact"]);
  }
}
